import { FermeService } from './services/ferme.service';
import { NbAuthService } from '@nebular/auth';
import {TranslateService} from '@ngx-translate/core';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbMenuService } from '@nebular/theme';
import { Ferme } from './models/ferme.model';


@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(translate: TranslateService, private fermeService :FermeService,private menuService: NbMenuService, private analytics: AnalyticsService, private authService: NbAuthService) {
    translate.setDefaultLang('fr');

         // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fr');
  }

  ngOnInit() {
    
  }
}
